import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";
const initContexts = [];
const contextModel = (context) => {
  return {
    ...context,
    // context info
    id: context?.id ?? -1,
    contextId: context?.contextId ?? 1,
    name: context?.name ?? "",
    description: context?.description ?? "",
    // admin details
    code: context?.code ?? "",
    firstName: context?.firstName ?? "",
    lastName: context?.lastName ?? "",
    // typeof bool and contains interactions
    community: context?.community,
    // typeof bool and indicates if user has accespted by admin
    accepted: context?.accepted ?? 0,
    // typeof bool and indicates if user has left the group
    left: context?.left ?? 0,
    autoAccept: context?.autoAccept ?? false, // false: private / true: public
    // custom properties (combination)
    // display the context in the library
    inLibrary: context?.community && !context?.left,
  };
};

export default function useActiveContexts() {
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { data, isLoading, isError, refetch } = useQuery(
    ["contexts", projectId, sessionId],
    () =>
      api.getActiveContexts({ projectId, sessionId }).then((data) => {
        if (Array.isArray(data?.contexts)) {
          return data.contexts.map((context) => contextModel(context));
        }
        return initContexts;
      }),
    {
      /*  refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: Infinity, */
      placeholderData: () => initContexts,
    }
  );
  return {
    contexts: data, // all contexts
    libraryContexts: data.filter((context) => context.inLibrary), // contexts visible in library
    isLoading,
    isError,
    refetchContexts: refetch,
  };
}
